import { Spinner } from "react-activity";

const fallback = {
    fallback: <div className="carregamento-inicial"><Spinner color={"#46189a"} size={32} /></div>
}

export default fallback;